export default __webpack_public_path__ + "static/media/med-records-3.0b0ae61f.png";